import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';

export default class Checkbox {
  view: View;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  protected checkMarkContainer: ImageView;
  protected checkMark: ImageView;

  constructor(
    opts: Omit<ViewOpts, 'width' | 'height'> & {
      checked?: boolean;
      onToggle?: (checked: boolean) => void;
    },
  ) {
    this.view = new View({
      ...opts,
      width: 50,
      height: 50,
    });

    this.checkMarkContainer = new ImageView({
      superview: this.view,
      canHandleEvents: false,
      width: 36,
      height: 36,
      x: 7,
      y: 7,
    });

    this.checkMark = new ImageView({
      superview: this.view,
      canHandleEvents: false,
      image: 'assets/ui/shared/lossless/checkmark.png',
      width: 40,
      height: 35,
      x: 7,
      y: 2,
    });

    this.view.onInputStart = () => {
      this.toggle();
    };

    this.onToggle = opts.onToggle;
    this.setChecked(opts.checked || false);
  }

  setChecked(isChecked: boolean) {
    this.checked = isChecked;
    this.checkMarkContainer.setImage(
      this.checked
        ? 'assets/ui/shared/lossless/checkmark_container_active.png'
        : 'assets/ui/shared/lossless/checkmark_container.png',
    );
    this.checkMark.style.visible = this.checked;
  }

  toggle() {
    this.setChecked(!this.checked);
    if (this.onToggle) {
      this.onToggle(this.checked);
    }
  }
}
